import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, MailOpen } from "lucide-react";

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
}

export default function AdminContactMessages() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/admin/contact-messages")
      .then(({ data }) => setMessages(data))
      .catch(() => setMessages([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section
      data-testid="admin-contact-messages-panel"
      className="mt-10 rounded-2xl border border-white/10 bg-[#0E0E12] overflow-hidden"
    >
      <div className="p-6 flex items-center justify-between">
        <div>
          <div className="font-mono-label text-[#00E5FF]">Inbox</div>
          <h2 className="font-display text-2xl mt-1">Contact form submissions</h2>
        </div>
        <span className="font-mono-label text-white/50">
          {messages.length} messages
        </span>
      </div>

      {loading ? (
        <div className="flex justify-center py-10">
          <Loader2 className="h-6 w-6 animate-spin text-white/40" />
        </div>
      ) : messages.length === 0 ? (
        <div className="text-center py-10 text-white/50" data-testid="admin-contact-empty">
          No messages yet.
        </div>
      ) : (
        <div className="divide-y divide-white/5 max-h-[520px] overflow-y-auto">
          {messages.map((m) => (
            <div
              key={m.id}
              data-testid={`admin-contact-row-${m.id}`}
              className="px-6 py-4 hover:bg-white/[0.02] transition-colors"
            >
              <div className="flex items-center justify-between gap-4 flex-wrap">
                <div className="flex items-center gap-2 min-w-0">
                  <MailOpen className="h-3.5 w-3.5 text-[#E0007A] flex-shrink-0" />
                  <span className="font-medium text-white truncate">{m.subject}</span>
                </div>
                <span className="text-xs text-white/40 font-mono flex-shrink-0">
                  {formatDate(m.created_at)}
                </span>
              </div>
              <div className="mt-1.5 text-xs text-white/50">
                {m.name} &middot;{" "}
                <a
                  href={`mailto:${m.email}`}
                  className="text-[#00E5FF] hover:text-white underline underline-offset-4"
                >
                  {m.email}
                </a>
              </div>
              <p className="mt-2 text-sm text-white/75 leading-relaxed whitespace-pre-wrap">
                {m.message}
              </p>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
